import { Button, CircularProgress, Switch } from "@mui/material";
import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "../../axios/axios";
import { toast } from "react-toastify";
import { useContext } from "react";
import { AuthenticationContext } from "../../App";
const ResetPassword = () => {
    const location = useLocation();
    const dealerToken = location.pathname.substring(15, location.pathname.length);
    const DealerLoggedData = JSON.parse(localStorage.getItem("DealerLoggedData"));
    const { setAuthData } = useContext(AuthenticationContext);
    const [userType, setUserType] = useState(true);
    const [resetPwd, setresetPwd] = useState(false);
    const [resetLinkMsg, setresetLinkMsg] = useState(false);
    const navigate = useNavigate();
    const [errMsg, setErrMsg] = useState({
        "remember_token": false,
        "newpassword": false,
        "confirmpassword": false
    });
    const [formInput, setFormInput] = useState({
        "remember_token": dealerToken,
        "newpassword": "",
        "confirmpassword": ""
    });
    const [loading, setLoading] = useState(false);

    const handleLogin = async (e) => {
        e.preventDefault();
        if (formInput.newpassword?.length < 8 || formInput.confirmpassword?.length < 8) {
            setErrMsg({ ...errMsg, newpassword: true, confirmpassword: true });
            return;
        } else if (formInput.newpassword !== formInput.confirmpassword) {
            setErrMsg({ ...errMsg, newpassword: false, confirmpassword: true });
            return;
        } else {
            setErrMsg({
                "remember_token": false,
                "newpassword": false,
                "confirmpassword": false
            });
            setLoading(true);
            const resp = await axios
                .post("/reset/password", formInput)
                .then((data) => {
                    const respCode = data?.data?.resp_code;
                    if (respCode < 400) {
                        toast.success(data.data?.message);
                        setLoading(false);
                        setFormInput({
                            "remember_token": "",
                            "newpassword": "",
                            "confirmpassword": ""
                        });
                        navigate("/login");
                    }
                })
                .catch((err) => {
                    toast.error("Passwoord reset not completed..!");
                    setLoading(false);
                });
        }
    };
    useEffect(() => {
        const tokenId = localStorage.getItem("dealerModuleToken");
        if (tokenId) {
            navigate("/");
        }
    }, []);

    useEffect(() => {
        if (
            DealerLoggedData !== null &&
            DealerLoggedData !== undefined &&
            Object.keys(DealerLoggedData)?.length > 0
        ) {
            setFormInput(DealerLoggedData);
        } else {
            setFormInput({
                ...formInput,
                "newpassword": "",
                "confirmpassword": ""
            });
        }
    }, []);
    return (
        <div className="login_page select-none">
            <div className="img_flx_sec">
                <img src="/images/login_bg.png" alt="login page" />
                <div className="img_shadow"></div>
                <div className="content_sec">
                    <h1 className="login_head_text">Discover, Collaborate, Win</h1>
                    <p className="sub_para">
                        Discover customer pain points, Collaborate to achieve those using
                        OhhTo and get more bonus and get customers.{" "}
                        <Link className="font-[500] underline underline-offset-4">
                            View More..
                        </Link>
                    </p>
                </div>
            </div>
            <div className="cont_flx_sec">
                <div className="log_box">
                    <div className="mb-[22px]">
                        <img src="/images/site_logo2.png" alt="site logo" />
                    </div>
                    <h2 className="heading">Reset Password</h2>
                    <p className="sub_heading"></p>

                    <form
                        className={`${resetPwd && "py-[30px]"}`}
                        onSubmit={handleLogin}
                    >
                        <div className="form_control">
                            <label
                                className="justify-between items-center"
                                style={{ display: "flex" }}
                            >
                                Password
                                <span
                                    className={`font-[500] text-[13px] text-[red] ${!errMsg.newpassword && "hidden"
                                        }`}
                                >
                                    Invalid Password
                                </span>
                            </label>
                            <div className="input_box relative">
                                <div className="placeholder_icon">
                                    <img src="/images/fi_lock.svg" alt="placeholde icon" />
                                </div>
                                <input
                                    type="password"
                                    placeholder="8+ Character required"
                                    value={formInput.newpassword}
                                    onChange={(e) =>
                                        setFormInput({ ...formInput, newpassword: e.target.value })
                                    }
                                    required={true}
                                />
                            </div>
                        </div>
                        <div className="form_control">
                            <label
                                className="justify-between items-center"
                                style={{ display: "flex" }}
                            >
                                Confirm Password
                                <span
                                    className={`font-[500] text-[13px] text-[red] ${!errMsg.confirmpassword && "hidden"
                                        }`}
                                >
                                    Invalid Password
                                </span>
                            </label>
                            <div className="input_box relative">
                                <div className="placeholder_icon">
                                    <img src="/images/fi_lock.svg" alt="placeholde icon" />
                                </div>
                                <input
                                    type="password"
                                    placeholder="8+ Character required"
                                    value={formInput.confirmpassword}
                                    onChange={(e) =>
                                        setFormInput({ ...formInput, confirmpassword: e.target.value })
                                    }
                                    required={true}
                                />
                            </div>
                        </div>


                        <Button type="submit" className="submit_btn" disabled={loading}>
                            {loading && (
                                <CircularProgress
                                    size={20}
                                    style={{ color: "white" }}
                                    className="mr-[13px]"
                                />
                            )}
                            ResetPassword
                        </Button>


                    </form>

                    <div className="mt-[20px] text-[#747587] text-[13px] text-center">
                        Copyright © ohhto.io. All Rights Reserved
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ResetPassword;
